import { useOutletContext } from 'react-router';
import { SettingsCertification } from '@views/shared/certification';
import { CertificationType } from '@pages/types';
import { Title } from 'common-components';
import { useAppTranslation } from '@hooks';

const SettingsCertificationPage = () => {
  const { certification } = useOutletContext<{ certification: CertificationType }>();
  const { translate } = useAppTranslation();

  return (
    <>
      <Title preset="singlePageTitle" style={{ marginBottom: 22 }}>
        {translate('common.settings')}
      </Title>
      <SettingsCertification
        includedFormParts={['form', 'settings', 'info', 'managers', 'audience']}
        state={'editing'}
        certification={certification}
      />
    </>
  );
};

export default SettingsCertificationPage;
